import { render } from "./EmployeeDashboard.vue?vue&type=template&id=79c6163f&ts=true"
import script from "./EmployeeDashboard.vue?vue&type=script&lang=ts"
export * from "./EmployeeDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__